var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "../scss/header.scss";
import defaultLogoImage from "../images/bank-of-ireland-logo-new-branding.svg";
import mobileLogoImage from "../images/bank-of-ireland-logo-new-branding-mobile.svg";
import boiukLogoImage from "../images/boiuk-header-logo.svg";
// Site check
var siteURL = window.location.hostname;
var logoImage = (siteURL.indexOf('uk') !== -1) ? (boiukLogoImage) : (defaultLogoImage);
// screen width checks
export var isMobile = window.innerWidth <= 767 ? true : false;
if (isMobile) {
    logoImage = mobileLogoImage;
}
var Header = function (_a) {
    var logo = _a.logo, left = _a.left, right = _a.right;
    return (_jsxs("header", __assign({ className: "Header" }, { children: [left, logo && (_jsx("a", __assign({ className: "Header__logo", href: logo.destination || "/", title: "Bank of Ireland" }, { children: _jsx("img", { "aria-label": "Bank of Ireland Logo", src: logo.image || logoImage, width: "96", height: "112" }) }))), right] })));
};
export default Header;
